import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import 'quill-mention';
import posthog from 'posthog-js'

posthog.init(
  'phc_dY5gHgUGQe6tXIP4rx2pMGPPuohzjdYz9cfWF9xUIJx',
  {
    api_host: 'https://us.i.posthog.com',
    defaults: '2026-01-30'
  }
)

bootstrapApplication(AppComponent, appConfig)
  .catch((err) => console.error(err));
